export interface QrRedirect {
  destinationContent: string;
  destinationUrl: string | null;
  magazineIssue: string;
  qrKind:
    | "podcast"
    | "itdb"
    | "creatives"
    | "install"
    | "spot"
    | "profile"
    | "market"
    | "htc";
}

const qrRedirects: Record<string, QrRedirect> = {
  "htc-onboarding": {
    destinationContent: "HTC Onboarding",
    destinationUrl:
      "https://drive.google.com/file/d/1E_515IvAYjOAsJS2Mh6cN8Ncwmo-dVxj/view",
    magazineIssue: "HTC",
    qrKind: "htc",
  },
  "htc-4": {
    destinationContent: "HereWeAre Theatre Club 4",
    destinationUrl: "https://www.instagram.com/herewearetheatreclub/",
    magazineIssue: "HTC-4",
    qrKind: "htc",
  },
  "mag-2026-09-podcast": {
    destinationContent: "Podcast",
    destinationUrl:
      "https://www.youtube.com/playlist?list=PLNMB2CeexbEEudjOn1FfEFGnw4xSa515Y",
    magazineIssue: "2026-09",
    qrKind: "podcast",
  },
  "mag-2026-09-itdb": {
    destinationContent: "ITDb",
    destinationUrl: "https://internationaltheatredatabase.com/",
    magazineIssue: "2026-09",
    qrKind: "itdb",
  },
  "mag-2026-09-creatives": {
    destinationContent: "ITDb Creative 206",
    destinationUrl: "https://internationaltheatredatabase.com/creatives/206",
    magazineIssue: "2026-09",
    qrKind: "creatives",
  },
  "mag-2026-09-install": {
    destinationContent: "HereWeAre App Store",
    destinationUrl: "https://link.hereweare.io/AppStore",
    magazineIssue: "2026-09",
    qrKind: "install",
  },
  "ssaf-2026-xbanner": {
    destinationContent: "SSAF Spot",
    destinationUrl:
      "https://spot.hereweare.io/ssaf?utm_source=qr&utm_medium=offline&utm_campaign=ssaf_2026&utm_content=xbanner&qr_id=ssaf-2026-xbanner",
    magazineIssue: "SSAF-2026",
    qrKind: "spot",
  },
  "ssaf-2026-poster": {
    destinationContent: "SSAF Spot",
    destinationUrl:
      "https://spot.hereweare.io/ssaf?utm_source=qr&utm_medium=offline&utm_campaign=ssaf_2026&utm_content=poster&qr_id=ssaf-2026-poster",
    magazineIssue: "SSAF-2026",
    qrKind: "spot",
  },
  "ssaf-2026-programbook": {
    destinationContent: "SSAF Spot",
    destinationUrl:
      "https://spot.hereweare.io/ssaf?utm_source=qr&utm_medium=offline&utm_campaign=ssaf_2026&utm_content=programbook&qr_id=ssaf-2026-programbook",
    magazineIssue: "SSAF-2026",
    qrKind: "spot",
  },
  "ssaf-2026": {
    destinationContent: "SSAF Spot",
    destinationUrl:
      "https://spot.hereweare.io/ssaf?utm_source=qr&utm_medium=offline&utm_campaign=ssaf_2026&utm_content=general&qr_id=ssaf-2026",
    magazineIssue: "SSAF-2026",
    qrKind: "spot",
  },
  "promo-card-2026-profile": {
    destinationContent: "ITDb Profile",
    destinationUrl: "https://profile.hereweare.io/",
    magazineIssue: "PROMO-CARD-2026",
    qrKind: "profile",
  },
  "promo-card-2026-market": {
    destinationContent: "ITDb Market",
    destinationUrl: "https://market.hereweare.io/",
    magazineIssue: "PROMO-CARD-2026",
    qrKind: "market",
  },
};

export default qrRedirects;
